module.exports = __webpack_public_path__ + "img/bote_basura.ab992529.svg";